<template>
  <div class="footer-nav flex-center">
    <div>底部版权</div>
  </div>
</template>

<script>
export default {
  name: "FooterNav"
}
</script>